<div class="activity-reorder">
	<div class="activity-sort-container">
		<div
			cdkDropList
			class="list"
			role="list"
			(cdkDropListDropped)="drop($event)">
			<div
				#listItem
				cdkDrag
				tabindex="0"
				class="reorder-list-item"
				role="listitem"
				*ngFor="let activity of activities; let i = index"
				[attr.aria-label]="'aria-ng-sortable_inform-reorderable-name' | translate: {name: activity.name}"
				accessibleDropList
				[count]="activities.length"
				[currentIndex]="i"
				[name]="activity.name"
				[itemId]="activity.activity_id"
				(activeItemChange)="onActiveItemChange($event)"
				(cancelReorder)="onCancelReorder($event)"
				(finalizePosition)="onFinalizePosition()">
					{{ activity.name }}
				</div>
		</div>
	</div>
	<div class="go-sidepanel-footer">
		<button class="tertiary-btn cancel-btn" (click)="cancel()" translate="common_cancel"></button>
		<button class="primary-btn save-btn" (click)="save()" translate="common_save-and-close"></button>
	</div>
</div>
